<div class="container-fluid">
  <div class="row" id="consequencesButtons">
    <div class="col">
      <button
        (click)="addConsequenceButtonClicked()"
        class="side-menu-button2 w-100"
        id="addConsequenceButton"
      >
        + Consequence
      </button>
    </div>

  </div>
  <p-table
    id="consequences"
    [value]="filteredConsequences()"
    #dt
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="loadingConsequences()"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
  >
    <ng-template pTemplate="caption">
      <div class="container text-center">
        <div class="row">
          <div class="col">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                placeholder="Consequence Name"
                id="searchBarInput"
                class="w-100"
                [(ngModel)]="searchKeyword"
              />
            </span>
          </div>
        </div>

        <div class="row mt-3" id="consequencesFiltersButtons">
          <div class="d-flex flex-wrap gap-3 justify-content-end">
            @if(!includeDeleted()) {
            <p-button
              id="includeDeletedButton"
              [style]="{
                color: 'red',
                backgroundColor: 'white',
                border: '2px solid red',
                'border-radius': '10px'
              }"
              label="Include Deleted"
              icon="pi pi-trash"
              (onClick)="toggleIncludeDeleted()"
            />
            } @else {
            <p-button
              [style]="{
                color: 'white',
                backgroundColor: 'red',
                border: '2px solid white',
                'border-radius': '10px'
              }"
              label="Exclude Deleted"
              icon="pi pi-trash"
              (onClick)="toggleIncludeDeleted()"
            />
            }

            <p-button
              label="Clear"
              [style]="{
                'border-radius': '10px',
                border: '2px solid #719eb6'
              }"
              icon="pi pi-filter-slash"
              (click)="clearSearch()"
            />
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="body" let-consequence>
      <app-consequence
        [consequence]="consequence"
        [id]="consequence.PatientBehaviorConsequence"
      ></app-consequence>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no Consequences yet.
      </p>
    </ng-template>
  </p-table>

  @if (showAddConsequence()) {
  <div
    class="supervisor-dialog-backdrop"
  ></div>
  <dialog class="supervisor-dialog" open>
    <app-add-consequence
      [patientID]="patientID()"
      (close)="onCloseAddConsequence(true)"
    />
  </dialog>
  }
</div>
